import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { List } from 'immutable'
import { withRouter } from 'react-router-dom'
import messages from 'components/Apps/EnvironmentMonitor/translate'
import { viewList } from 'helpers/environmentMonitor'
import {
  logMonitorActivity,
  setActiveViewType,
} from 'reducers/environmentMonitor/reducer'
import SelectList from 'components/common/SelectList'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import 'styles/app/apps/tab-filter.scss'
import { EVENT_TYPES } from 'routes/App/Apps/MonitorsAndAlerts/logTypes'

function ViewTypeMenu({
  intl: { formatMessage },
  viewType,
  licenseeName,
  currentApp: { id: licenseeApplicationId, applicationId },
  history: {
    location: { pathname },
  },
  logMonitorActivity,
  setActiveViewType,
  activeSite,
}) {
  const onChangeFilter = (evt, tabValue) => {
    const activeViewType = ifWindowWidthLessThan(992) ? evt.index : tabValue
    const logData = {
      licensee_application: licenseeApplicationId,
      application: applicationId,
      site: activeSite,
      event_name: EVENT_TYPES.TAB_CLICK,
      tab_name: activeViewType,
      application_url: pathname,
      referrer: null,
    }

    setActiveViewType(activeViewType)
    logMonitorActivity(logData)
  }

  // a temporary solution, in the next release the number of tabs will be placed on the backend side
  const getViewListByLicenseeName = () => {
    const data = []
    const keys = ['transparency', 'speed']

    viewList.forEach(view => {
      if (licenseeName === 'Aquachile' && keys.includes(view.name)) {
        return
      }

      data.push(view)
    })

    return data
  }

  const renderMobileFilter = () => {
    const sensorList = getViewListByLicenseeName().map(item => ({
      value: item.component,
      text: formatMessage(messages[item.name]),
    }))

    return (
      <SelectList
        name="type"
        label={formatMessage(messages.typeFilter)}
        list={List(sensorList)}
        value={viewType}
        onChange={onChangeFilter}
        map={{
          index: 'value',
          text: 'text',
        }}
      />
    )
  }

  return (
    <div className="type-filter">
      {ifWindowWidthLessThan(992) ? (
        renderMobileFilter()
      ) : (
        <Tabs onChange={onChangeFilter} value={viewType}>
          {getViewListByLicenseeName().map(elem => (
            <Tab
              label={
                elem.name === 'pew' ? 'PEW' : formatMessage(messages[elem.name])
              }
              value={elem.component}
              key={`key_${elem.component}`}
              className="filter-tab"
            />
          ))}
        </Tabs>
      )}
    </div>
  )
}

export default withRouter(
  connect(
    state => ({
      viewType: state.getIn(['environmentMonitor', 'viewType']),
      activeSite: state.getIn(['profile', 'siteId']),
      licenseeName: state.getIn(['profile', 'licenseeName']),
    }),
    {
      setActiveViewType,
      logMonitorActivity,
    },
  )(injectIntl(ViewTypeMenu)),
)
